export default __webpack_public_path__ + "static/media/actoctt-bold-webfont.ca7dcdc7.woff";